<template>
    <div>
        <van-uploader :after-read="resolveQR" />
        <div style="font-size:12px">{{qs}}</div>
        <div style="font-size:12px">{{qr}}</div>
        <customToast :toastRow="toastRow" :show="toastFlag"></customToast>
    </div>
</template>
<script>
import QrCode from "qrcode-decoder";
import customToast from "@/components/toast.vue";
import { getQrUrl } from "@/util/qrcode.js";
export default {
    components: {
        customToast,
    },
    data() {
        return {
            toastFlag: false,
            toastRow: {},
            assetsId: "",
            role: "",
            qr: "",
            qs: "",
            innerVisible: false,
            qrcode: "",
            qrs: "",
        };
    },
    created() {},
    methods: {
        resolveQR(event) {
            const result = getQrUrl(event.file);
            result
                .then((res) => {
                    this.qr = res;
                    if (res.data) {
                        // this.$toast("识别二维码成功!");
                        this.toastRow = {
                            selId: 3,
                            title: "成功",
                            text: "识别二维码成功",
                        };
                        this.toastFlag = true;
                        setTimeout(() => {
                            this.toastFlag = false;
                        }, 1500);
                        this.assetsId = res.data.split("&")[0].split("=")[1];
                        this.role = res.data.split("&")[1].split("=")[1];
                        this.getData();
                    } else {
                        // this.$toast("识别二维码失败, 请重新上传");
                        this.toastRow = {
                            selId: 4,
                            title: "识别二维码失败, 请重新上传",
                            text: "识别二维码失败, 请重新上传",
                        };
                        this.toastFlag = true;
                        setTimeout(() => {
                            this.toastFlag = false;
                        }, 1500);
                    }
                })
                .catch((err) => {
                    // this.$toast(JSON.stringify(err));
                    this.toastRow = {
                        selId: 5,
                        title: JSON.stringify(err),
                        text: JSON.stringify(err),
                    };
                    this.toastFlag = true;
                        setTimeout(() => {
                            this.toastFlag = false;
                        }, 1500);
                });
        },
        getData() {},
    },
};
</script>
<style scoped>
::v-deep .van-dialog {
    width: 75% !important;
}
</style>